import { useEffect, useState } from 'react'
import { ethers } from 'ethers'
import { bnbDeod, bnbDeodABI } from '../components/sections/Abi/Content';

const useDeodBalanceOf = (address) => {
    const [deodBalance, setDeodBalance] = useState(0);
    const getDeodBalance = async () => {
        try {
            if (window?.ethereum) {
                const provider = new ethers.providers.Web3Provider(window.ethereum);
                const signer = provider.getSigner();
                const tokenContract = new ethers.Contract(bnbDeod, bnbDeodABI, signer);
                const balanceOfUser = await tokenContract.balanceOf(address);
                setDeodBalance(ethers.utils.formatEther(balanceOfUser));
            }
        } catch (error) {
            console.log("getDeodBalance error", error);
        }
    }
    useEffect(() => {
        getDeodBalance();
    }, [address])
    // console.log("deodBalance", deodBalance)
    return {deodBalance}
}

export default useDeodBalanceOf